export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 9,
        name_ca: 'Alumini',
        name_es: 'Aluminio',
        name_en: 'Aluminum'
    }, {
        id: 2,
        name_ca: 'Alumini blanc',
        name_es: 'Aluminio blanco',
        name_en: 'Aluminum white'
    }, {
        id: 3,
        name_ca: 'Alumini bronze',
        name_es: 'Aluminio bronce',
        name_en: 'Aluminum bronze'
    }, {
        id: 4,
        name_ca: 'Alumini natural',
        name_es: 'Aluminio natural',
        name_en: 'Aluminum natural'
    }, {
        id: 5,
        name_ca: 'Fusta pintada',
        name_es: 'Madera pintada',
        name_en: 'Wood, painted'
    }, {
        id: 6,
        name_ca: 'Fusta envernissada',
        name_es: 'Madera barnizada',
        name_en: 'Wood, barnished'
    }, {
        id: 10,
        name_ca: 'Doble fusteria alumini i fusta',
        name_es: 'Doble carpintería aluminio y madera',
        name_en: 'Double window aluminum and wood'
    }, {
        id: 7,
        name_ca: 'Acer',
        name_es: 'Acero',
        name_en: 'Steel'
    }, {
        id: 8,
        name_ca: 'PVC (Policlorur de Vinil)',
        name_es: 'PVC (Policloruro de Vinilo)',
        name_en: 'PVC (Polyvinylchloride)'
    }
]





// WEBPACK FOOTER //
// ./src/options/external_carpentry_types.js